import { postData } from '@/api/data'

import type { RecordType } from './types'

export const getRecords = (parentID: string, params: { type: string; viewName: string }) => {
  const formData = {
    Actions: {
      Action: '',
      Items: []
    },
    BundleType: params.type,
    Filter: [
      { Name: 'WorkplaceUuid', Operator: 'exact', Value: parentID }
    ],
    Pager: { Page: 1, RecsOnPage: 10 },
    Sort: [],
    ViewName: params.viewName
  }

  return postData<{ records: RecordType[] | null }>(formData).then((response) => {
    if (!response.done) throw new Error(response.msg || 'Не удалось загрузить посты рабочего места.')
    return {
      records: response?.data?.records || []
    }
  })
}
